import {FlowController} from "./FlowController";
import {Messages} from "../../Messages";
import {SubscriptionOfferStore} from "../../../client/state/SubscriptionOfferStore";
import {startSubscriptionFlow} from "./FlowEntrypoint.js";


export class SubscribeFlowController extends FlowController {
    actionButtonTestId = "subscribeWithBlinkBtn";
    actionButtonDefaultAnid = "subscribe-button";

    onClickAuthenticated() {
        startSubscriptionFlow();
    }

    onClickNotAuthenticated() {
        startSubscriptionFlow();
    }

    onLoginClick() {
        startSubscriptionFlow(false, true);
    }

    getHeaderDefaultText() {
        const offers = SubscriptionOfferStore.all();
        let offerInfo = "";

        if (offers.length === 1) {
            offerInfo = ` (${offers[0].getPrice()}/${offers[0].getCycleDuration(true)})`;
        } else if (offers.length === 2) {
            offerInfo = ` (${offers[0].getPrice()}/${offers[0].getCycleDuration(true)} or ${offers[1].getPrice()}/${offers[1].getCycleDuration(true)})`;
        }

        return super.getHeaderDefaultText() || Messages.subscriptionWall(offerInfo);
    }

    getActionButtonDefaultLabel() {
        return super.getActionButtonDefaultLabel() || Messages.subscribe;
    }

    getLoginFooterMessage() {
        return Messages.alreadySubscriber;
    }
}
